import ClassNameExtendableHoC from '../Generic/ClassNameExtendableHoC';
import DefaultPropsHoC from '../Generic/DefaultPropsHoC';
import LoadingSpinner from './index';

const LoadingSingleInline = ClassNameExtendableHoC(DefaultPropsHoC(LoadingSpinner, { size: '2x' }), '_quar_');

export default LoadingSingleInline;
